import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box, Text, VStack } from '@chakra-ui/react';
import { Field } from 'formik';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { stackSpacing, formLabelStyling, stackStyling, descriptionStyling } from 'components/forms/new/formStyles';
import NameField from 'components/forms/new/formikFormFields/NameField';

const CallingRatePrefixField = ({ darkMode, errors, touched, ...props }) => {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <FormControl
      sx={{ margin: '0 !important' }}
     isInvalid={!!errors.prefix && touched.prefix}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Stack direction="row" spacing={stackSpacing} sx={stackStyling(true)}>
        <Box>
          <FormLabel sx={formLabelStyling(darkMode)}>
            Prefix <span style={{ color: '#e53e3e' }}>*</span>
          </FormLabel>
          <Text sx={descriptionStyling} maxWidth={250}>
            Enter the prefix for this calling rate.
          </Text>
        </Box>
 <Box flex="1" minWidth="450px">
                     <Box sx={{ display: 'flex', width: '100%', alignItems: 'flex-start', paddingTop: '8px' }}>
          <VStack width="100%" alignItems="normal">
            <Field
                                       component={NameField}
                                       id="prefix"
                                       name="prefix"
                                       validate={value => !value && 'Prefix is required'}
                                       error={errors.prefix}
                                       {...props}
                                   />
          </VStack>
        </Box>
            </Box>
        {isHovered && (
          <FieldToolTip
            label="Enter a prefix."
            ariaLabel="calling-rate-prefix-tip"
            left="25px"
            top="30px"
          />
        )}
      </Stack>
    </FormControl>
  );
};

export default CallingRatePrefixField;
